<template>
  <UContainer class="relative mx-auto my-10 px-4 sm:px-6 lg:px-8 max-w-6xl min-h-[360px]">
    <AppImage
      :path="imagePath"
      :alt="imageAlt"
      :credit="imageCredit"
      :width="imageWidth"
      :height="imageHeight"
      class="z-0 md:absolute shadow-md rounded-2xl w-auto md:h-full max-h-[500px]"
      img-classes="md:brightness-[0.60]"
      :class="{ 'left-2': alignRight, 'right-2': !alignRight }"
    />
    <div
      class="relative flex flex-col gap-4 drop-shadow-2x max-md:mx-auto md:px-6 py-10 max-w-[500px] start"
      :class="{ 'md:ml-auto': alignRight, 'md:mr-auto': !alignRight }"
    >
      <h2
        class="font-semibold text-white max-md:text-xl md:text-3xl uppercase"
      >
        <span
          class="inline-flex z-[1] relative bg-white px-2 py-1 rounded-sm text-black"
          v-text="title1"
        />
        {{ title2 }}
      </h2>
      <p
        class="font-semibold text-white"
        v-text="text"
      />
      <UButton
        :class="{ 'self-end': alignRight, 'self-start': !alignRight }"
        :ui="{
          base: 'font-semibold max-md:self-center focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:cursor-not-allowed aria-disabled:opacity-75 flex-shrink-0',
          // font: 'font-semibold',
          // rounded: 'rounded-md',
          // truncate: 'text-left break-all line-clamp-1',
          // block: 'w-full flex justify-center items-center',
          // inline: 'inline-flex items-center',
        }"
        class="text-black uppercase"
        icon="i-lucide-pen"
        size="xl"
        label="Signer"
        to="#sign"
      />
    </div>
  </ucontainer>
</template>

<script lang="ts" setup>
defineProps({
  imagePath: {
    type: String,
    required: true,
    // default: undefined,
  },
  imageAlt: {
    type: String,
    required: false,
    // default: undefined,
  },
  imageCredit: {
    type: String,
    required: true,
    // default: undefined,
  },
  imageWidth: {
    type: Number,
    required: false,
    // default: undefined,
  },
  imageHeight: {
    type: Number,
    required: false,
    // default: undefined,
  },
  title1: {
    type: String,
    required: true,
    // default: undefined,
  },
  title2: {
    type: String,
    required: true,
    // default: undefined,
  },
  text: {
    type: String,
    required: true,
    // default: undefined,
  },
  alignRight: {
    type: Boolean,
    required: false,
    default: true,
  },
})
</script>

<!-- <style>
.sss::before {
  content: "";
  display: block;
  position: absolute;
  top: -10%;
  left: -.25em;
  width: calc(100% + .3em);
  height: 110%;
  background-color: #fff;
  clip-path: polygon(2% 0,25% 5%,50% 0%,75% 5%,99% 2%,100% 33%,99% 66%,100% 100%,75% 95%,50% 100%,25% 97%,2% 98%,2% 66%,1% 33%);
  z-index: -1;
}
</style> -->
